import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StkRcpt02Actions, { StkRcpt02Types } from '../Stores/StkRcpt02/Actions';

const getAppStore = state => state.app;

export function* stkRcpt02FetchStkRcpt02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(StkRcpt02Actions.stkRcpt02FetchStkRcpt02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkRcpt/indexProcess/STK_RCPT_02/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        StkRcpt02Actions.stkRcpt02FetchStkRcpt02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcpt02Actions.stkRcpt02FetchStkRcpt02Loading(false));
  }
}

export function* stkRcpt02CreateStkRcpt02({ hdrIds, toStorageBinId }) {
  try {
    yield put(StkRcpt02Actions.stkRcpt02CreateStkRcpt02Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds,
      toStorageBinId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkRcpt/createProcess/STK_RCPT_02`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(StkRcpt02Actions.stkRcpt02CreateStkRcpt02Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcpt02Actions.stkRcpt02CreateStkRcpt02Loading(false));
  }
}

export function* stkRcpt02GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/stkIssDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(StkRcpt02Types.STK_RCPT02_GO_TO_DOCUMENT, stkRcpt02GoToDocument),
  takeLatest(StkRcpt02Types.STK_RCPT02_FETCH_STK_RCPT02, stkRcpt02FetchStkRcpt02),
  takeLatest(StkRcpt02Types.STK_RCPT02_CREATE_STK_RCPT02, stkRcpt02CreateStkRcpt02)
];
